/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_CtaInputs */

const en_directory_guide_cta = /** @type {(inputs: Directory_Guide_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a product`)
};

const zh_directory_guide_cta = /** @type {(inputs: Directory_Guide_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交产品`)
};

/**
* | output |
* | --- |
* | "Submit a product" |
*
* @param {Directory_Guide_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_cta = /** @type {((inputs?: Directory_Guide_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_cta(inputs)
	return zh_directory_guide_cta(inputs)
});
export { directory_guide_cta as "directory.guide.cta" }